export default "__VITE_ASSET__DogYaV5N__"